import { render, staticRenderFns } from "./Leitfaden.vue?vue&type=template&id=2f6df8d3&scoped=true&"
import script from "./Leitfaden.vue?vue&type=script&lang=js&"
export * from "./Leitfaden.vue?vue&type=script&lang=js&"
import style0 from "./Leitfaden.vue?vue&type=style&index=0&id=2f6df8d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6df8d3",
  null
  
)

export default component.exports